// extracted by mini-css-extract-plugin
export default {"button":"SaveForLateButton_button__Y2WHk"};